import { FormHelp, Label } from '@zillow/constellation';
import { LabeledSelectField } from '../../common';
import { SELF_REPORTED_CREDIT } from '../../../constants';

const CREDIT_OPTIONS = Object.entries(SELF_REPORTED_CREDIT).map(([key, value]) => ({ label: value, value: key }));

const CreditSelectField = props => (
    <LabeledSelectField
        renderLabel={labelProps => <Label {...labelProps}>Credit score</Label>}
        helpText="It’s okay to estimate."
        options={CREDIT_OPTIONS}
        description={<FormHelp>It’s okay to estimate.</FormHelp>}
        {...props}
    />
);

export default CreditSelectField;
